import GroupView from "@/components/GroupView";
import Financement from "@/pages/saas/Financement";
import SourcesCapital from "@/pages/saas/SourcesCapital";
import Courtage from "@/pages/saas/Courtage";
import Immobilier from "@/pages/saas/Immobilier";

export default function Capital() {
  return (
    <GroupView
      groupKey="capital"
      groupLabel="Capital"
      overline="Module groupe · Financement & actifs"
      tabs={[
        { slug: "financement", label: "Financement", Component: Financement },
        { slug: "sources", label: "Sources de capital", Component: SourcesCapital },
        { slug: "courtage", label: "Courtage", Component: Courtage },
        { slug: "immobilier", label: "Immobilier", Component: Immobilier },
      ]}
    />
  );
}
